/* eslint-disable i18next/no-literal-string */
const VentiLogo = (
    props: React.ImgHTMLAttributes<HTMLImageElement>
): React.ReactElement => {
    return <img src="/venti-logo.png" alt="venti-logo" {...props} />
}
export default VentiLogo
